import EntityTable from './EntityTable';

export default EntityTable;
